import React, { Component } from 'react';
import Header from './components/Header';
import SwatchButtons from './components/SwatchButtons';

class App extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <SwatchButtons swatchType="shirt-color" />
        </div>
      </div>
    );
  }
}

export default App;
